/**
 * nova-testimonials.js
 * FILE: assets/nova-testimonials.js
 *
 * Usage: Loaded automatically via the section liquid file.
 * Initialised per section with: new NovaTestimonials('section-id')
 */

class NovaTestimonials {
  constructor(sectionId) {
    this.root    = document.getElementById(sectionId);
    if (!this.root) return;

    this.track   = this.root.querySelector('.nova-tm__track');
    this.dots    = [...this.root.querySelectorAll('.nova-tm__dot')];
    this.prev    = this.root.querySelector('.nova-tm__arrow--prev');
    this.next    = this.root.querySelector('.nova-tm__arrow--next');
    this.total   = this.root.querySelectorAll('.nova-tm__slide').length;
    this.current = 0;
    this.autoplay  = this.root.dataset.autoplay === 'true';
    this.delay     = parseInt(this.root.dataset.delay, 10) || 4000;
    this.timer     = null;
    this.startX    = 0;

    this._bindEvents();
    this.goTo(0);
    if (this.autoplay) this._startAuto();
  }

  goTo(index) {
    this.current = ((index % this.total) + this.total) % this.total;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
  }

  _next() { this.goTo(this.current + 1); }
  _prev() { this.goTo(this.current - 1); }

  _startAuto() {
    this.timer = setInterval(() => this._next(), this.delay);
  }

  _stopAuto() {
    clearInterval(this.timer);
  }

  _resetAuto() {
    if (!this.autoplay) return;
    this._stopAuto();
    this._startAuto();
  }

  _bindEvents() {
    this.prev?.addEventListener('click', () => { this._prev(); this._resetAuto(); });
    this.next?.addEventListener('click', () => { this._next(); this._resetAuto(); });

    this.dots.forEach((d, i) => {
      d.addEventListener('click', () => { this.goTo(i); this._resetAuto(); });
    });

    /* Touch / swipe */
    this.track.addEventListener('touchstart', (e) => {
      this.startX = e.touches[0].clientX;
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      const diff = this.startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? this._next() : this._prev();
        this._resetAuto();
      }
    }, { passive: true });

    /* Keyboard navigation when section is focused */
    this.root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { this._prev(); this._resetAuto(); }
      if (e.key === 'ArrowRight') { this._next(); this._resetAuto(); }
    });

    /* Pause autoplay on hover */
    this.root.addEventListener('mouseenter', () => this._stopAuto());
    this.root.addEventListener('mouseleave', () => { if (this.autoplay) this._startAuto(); });
  }
}

/* Auto-init any section already in the DOM on script load */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="nova-tm-"]').forEach(el => {
    new NovaTestimonials(el.id);
  });
});